import {tgxApi} from "../../app/tgxApi";
import {getAuthorizationHeader, handleQueryError} from "../../helpers/utils/RtkQueryUtils";

export const tenantApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        getAllTenants: build.query({
            query: () => {
                return {
                    url: `/ajax/tenant`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        
    })
})

export const {
    useGetAllTenantsQuery,
    useLazyGetAllTenantsQuery

} = tenantApi